export const MESSAGE_CREDIT_NOT_ENOUGH_CODE = 1001
export const SEND_MESSAGE_PERMISSION_DENIED = 403

export const multiplyValue = (value, count) => {
  if (value) return Number(value) * count
  else return 0
}

export const isPaidPlan = (planId) => {
  return planId && (planId === 'free_tier' || planId === 'free')
}

export const totalPrice = (statisticValues) => {
  return statisticValues.reduce((acc, value) => {
    return Number(value) + acc
  }, 0)
}

export const setPriceRatio = (planId, freePrice, paidPrice) => {
  return isPaidPlan(planId) ? freePrice : paidPrice
}
